import TextArea from 'antd/lib/input/TextArea'
import { InPlaceEditor } from 'components/shared/in-place-editor'
import React, { useEffect, useState } from 'react'

const DescriptionInput = TextArea
export default DescriptionInput
